import React from 'react';
import Create_Exam from './Create_Exam';
import '../../CommonCSS/SocietyCSS.css'

const Create_ExamApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Create Exam</h5>
          </div>  
        </div>
        <Create_Exam/>
      </div>
    </div >
  );
};

export default Create_ExamApp;
